import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { EMAIL, EMAIL_LINK, PHONE } from "@/data/site";

const SECTIONS = [
  {
    title: "1. Who We Are",
    body: [
      "Sage Auto Group is a UK accident management company. This Privacy Policy explains how we collect, use, store and protect your personal information when you use our website or engage our services.",
      `If you have any questions about this policy or how we handle your data, contact us at ${EMAIL} or call ${PHONE}.`,
    ],
  },
  {
    title: "2. Information We Collect",
    body: [
      "When you contact us or submit an enquiry through this website, we may collect: your name, telephone number, email address, details about your accident and the vehicles involved, and any other information you choose to provide.",
      "We may also collect limited technical information automatically when you browse this website, such as your browser type and pages visited.",
    ],
  },
  {
    title: "3. How We Use Your Information",
    body: [
      "We use your information to respond to your enquiry, provide accident management services, coordinate recovery, storage, replacement vehicles and repairs through our trusted partner network, liaise with insurers and legal professionals on your behalf, and meet our legal and regulatory obligations.",
      "We will only use your information where we have a lawful basis to do so — typically to perform our contract with you, to comply with legal obligations, or for our legitimate interests in operating and improving our services.",
    ],
  },
  {
    title: "4. Sharing Your Information",
    body: [
      "To deliver our services, we share relevant information with trusted third parties where necessary, including recovery operators, vehicle storage facilities, repairers, hire vehicle providers, insurers and legal professionals.",
      "We never sell your personal information to third parties, and we never share it for unrelated marketing purposes.",
    ],
  },
  {
    title: "5. How Long We Keep Your Information",
    body: [
      "We retain personal information only for as long as necessary to provide our services, resolve your claim and satisfy legal, accounting or reporting requirements. When information is no longer required, it is securely deleted.",
    ],
  },
  {
    title: "6. Your Rights",
    body: [
      "Under UK data protection law, you have the right to access the personal information we hold about you, request correction of inaccurate information, request deletion of your information in certain circumstances, object to or restrict certain processing, and request a copy of your data in a portable format.",
      `To exercise any of these rights, contact us at ${EMAIL}. You also have the right to lodge a complaint with the Information Commissioner's Office (ICO).`,
    ],
  },
  {
    title: "7. Security",
    body: [
      "We take appropriate technical and organisational measures to protect your personal information against unauthorised access, loss or misuse. Access to your information is restricted to those who need it to provide our services.",
    ],
  },
  {
    title: "8. Changes To This Policy",
    body: [
      "We may update this Privacy Policy from time to time. Any changes will be published on this page with an updated revision date.",
      "This policy was last updated in July 2026.",
    ],
  },
];

const Privacy = () => (
  <div data-testid="privacy-page">
    <PageHero
      testId="privacy-hero"
      kicker="Legal"
      titleLines={["Privacy Policy"]}
      description="How Sage Auto Group collects, uses and protects your personal information."
    />
    <section className="mx-auto max-w-3xl px-6 py-24 md:px-10 md:py-32">
      {SECTIONS.map((section, i) => (
        <Reveal key={section.title} delay={0.02 * i}>
          <div className="border-b border-white/10 py-10" data-testid={`privacy-section-${i + 1}`}>
            <h2 className="font-serif text-2xl text-white">{section.title}</h2>
            {section.body.map((p, j) => (
              <p key={j} className="mt-4 text-base leading-relaxed text-zinc-400">{p}</p>
            ))}
          </div>
        </Reveal>
      ))}
      <Reveal>
        <p className="mt-10 text-sm text-zinc-500">
          Questions about your data? Email us at{" "}
          <a href={EMAIL_LINK} data-testid="privacy-email-link" className="text-gold transition-colors duration-300 hover:text-gold-hover">
            {EMAIL}
          </a>
          .
        </p>
      </Reveal>
    </section>
  </div>
);

export default Privacy;
